export async function getAllElapsedTime(server) {
  let endpoint = process.env.REACT_APP_DM_LOCAL
  if (server === "dev") {
    endpoint = process.env.REACT_APP_DM_DEV
  } else if (server === "stg") {
    endpoint = process.env.REACT_APP_DM_STG
  }

  return fetch(endpoint + '/dm/profiling/elapsed', {
    method: 'GET',
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Authorization": "Basic test",
      "Auth-Type": "BA"
    }
  })
}

export async function searchElapsedTime(server, search, page, pageSize) {
  let endpoint = process.env.REACT_APP_DM_LOCAL
  if (server === "dev") {
    endpoint = process.env.REACT_APP_DM_DEV
  } else if (server === "stg") {
    endpoint = process.env.REACT_APP_DM_STG
  }

  for (let key in search) {
    if (search[key] === "") {
      delete search[key]
    }
  }
  search["page"] = page
  search["pageSize"] = pageSize

  return fetch(endpoint + '/dm/profiling/elapsed/search', {
    method: 'POST',
    mode: "cors",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Authorization": "Basic test",
      "Auth-Type": "BA"
    },
    body: JSON.stringify(search)
  })
}

export async function searchDistinctModule(server) {
  let endpoint = process.env.REACT_APP_DM_LOCAL
  if (server === "dev") {
    endpoint = process.env.REACT_APP_DM_DEV
  } else if (server === "stg") {
    endpoint = process.env.REACT_APP_DM_STG
  }

  return fetch(endpoint + '/dm/profiling/elapsed/module/distinct', {
    method: 'GET',
    mode: "cors",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Authorization": "Basic test",
      "Auth-Type": "BA"
    }
  })
}

export async function searchDistinctMethod(server) {
  let endpoint = process.env.REACT_APP_DM_LOCAL
  if (server === "dev") {
    endpoint = process.env.REACT_APP_DM_DEV
  } else if (server === "stg") {
    endpoint = process.env.REACT_APP_DM_STG
  }

  return fetch(endpoint + '/dm/profiling/elapsed/method/distinct', {
    method: 'GET',
    mode: "cors",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Authorization": "Basic test",
      "Auth-Type": "BA"
    }
  })
}
